import { createStyles, Grid, makeStyles, Paper } from '@material-ui/core';
import {
	ExtendedTheme, Heading, TextBlock
} from 'neon-design-system';
import React from 'react';
import { EmailNeonSales } from '../../ui/EmailNeonSales';

const useStyles = makeStyles<ExtendedTheme>((theme: ExtendedTheme) =>
	createStyles({
		paper: {
			padding: theme.spacing(4)
		}
	}));

interface FurtherAssistanceEmailProps {
	className?: string;
}

export const FurtherAssistanceEmail = ({ className }: FurtherAssistanceEmailProps): JSX.Element => {
	const classes = useStyles();

	return (
		<Paper classes={{ root: [classes.paper, className].join(' ') }}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Heading styleName="headline1" color="white">If you need further assistance</Heading>
				</Grid>
				<Grid item xs={12}>
					<TextBlock styleName="body">
						<strong>Email us at</strong>
					</TextBlock>
					<EmailNeonSales />
				</Grid>
			</Grid>
		</Paper>
	);
};
